import './Welcome.scss';
import Component from './Welcome.js';
export default Component;
